'use strict';
import * as $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal from "./com.raquo.airstream.misc.-Map-Signal.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024$0024anon$002411 from "./dev.cheleb.scalamigen.-Form$$anon$11.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024$0024anon$00246 from "./dev.cheleb.scalamigen.-Form$$anon$6.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024$0024anon$00249 from "./dev.cheleb.scalamigen.-Form$$anon$9.js";
import * as $j_dev$002echeleb$002escalamigen$002epackage$0024package$0024$0024anon$00243 from "./dev.cheleb.scalamigen.package$package$$anon$3.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002ecollection$002e$002dString$002dParsers$0024 from "./scala.collection.-String-Parsers$.js";
import * as $j_scala$002epackage$0024 from "./scala.package$.js";
import * as $j_scala$002eutil$002e$002dFailure from "./scala.util.-Failure.js";
import * as $j_scala$002eutil$002e$002dSuccess from "./scala.util.-Success.js";
import * as $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024 from "./scala.util.control.-Non-Fatal$.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Form$() {
  this.Ha = null;
  this.Hb = false;
  this.Hc = null;
  this.Hd = false;
  this.H8 = null;
  this.H9 = false;
  this.He = null;
  this.Hf = false;
}
export { $c_Ldev_cheleb_scalamigen_Form$ as $c_Ldev_cheleb_scalamigen_Form$ };
$p = $c_Ldev_cheleb_scalamigen_Form$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_Form$;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Form$() {
}
export { $h_Ldev_cheleb_scalamigen_Form$ as $h_Ldev_cheleb_scalamigen_Form$ };
$h_Ldev_cheleb_scalamigen_Form$.prototype = $p;
$p.BH = (function() {
  if ((!this.Hb)) {
    this.Ha = new $j_dev$002echeleb$002escalamigen$002e$002dForm$0024$0024anon$00246.$c_Ldev_cheleb_scalamigen_Form$$anon$6();
    this.Hb = true;
  }
  return this.Ha;
});
$p.eU = (function() {
  if ((!this.Hd)) {
    this.Hc = new $j_dev$002echeleb$002escalamigen$002epackage$0024package$0024$0024anon$00243.$c_Ldev_cheleb_scalamigen_package$package$$anon$3(new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$3$2) => {
      $j_java$002elang$002e$002dObject.$m_sc_StringOps$();
      return $j_scala$002ecollection$002e$002dString$002dParsers$0024.$m_sc_StringParsers$().Ch(_$3$2);
    })), 0);
    this.Hd = true;
  }
  return this.Hc;
});
$p.BG = (function() {
  if ((!this.H9)) {
    this.H8 = new $j_dev$002echeleb$002escalamigen$002epackage$0024package$0024$0024anon$00243.$c_Ldev_cheleb_scalamigen_package$package$$anon$3(new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((str$2) => {
      try {
        var $x_1 = new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success($j_scala$002epackage$0024.$m_s_package$().jh().O4(str$2));
      } catch (e) {
        var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
        matchResult1: {
          var $x_1;
          var x2 = $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024.$m_s_util_control_NonFatal$().ht(e$2);
          if ((!x2.k())) {
            var $x_1 = new $j_scala$002eutil$002e$002dFailure.$c_s_util_Failure(x2.C());
            break matchResult1;
          }
          throw ((e$2 instanceof $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException) ? e$2.aZ : e$2);
        }
      }
      return $x_1.QL();
    })), $j_scala$002epackage$0024.$m_s_package$().jh().qS(0));
    this.H9 = true;
  }
  return this.H8;
});
$p.Oq = (function(condVar, fa, d, cond) {
  return new $j_dev$002echeleb$002escalamigen$002e$002dForm$0024$0024anon$00249.$c_Ldev_cheleb_scalamigen_Form$$anon$9($j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal.$c_Lcom_raquo_airstream_misc_MapSignal(), $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal.$c_Lcom_raquo_airstream_misc_MapSignal(), condVar.a4(), cond.Bc(), $j_java$002elang$002e$002dObject.$m_s_None$()), new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$3) => {
    var x$1$2 = (!(!x$1$3));
    if (x$1$2) {
      return "block";
    }
    if ((!x$1$2)) {
      return "none";
    }
    throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x$1$2);
  })), $j_java$002elang$002e$002dObject.$m_s_None$()), d, fa, condVar, cond);
});
$p.V4 = (function() {
  if ((!this.Hf)) {
    this.He = new $j_dev$002echeleb$002escalamigen$002e$002dForm$0024$0024anon$002411.$c_Ldev_cheleb_scalamigen_Form$$anon$11();
    this.Hf = true;
  }
  return this.He;
});
var $d_Ldev_cheleb_scalamigen_Form$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Form$, "dev.cheleb.scalamigen.Form$", ({
  iW: 1,
  nR: 1,
  nV: 1,
  nS: 1,
  nJ: 1
}));
export { $d_Ldev_cheleb_scalamigen_Form$ as $d_Ldev_cheleb_scalamigen_Form$ };
var $n_Ldev_cheleb_scalamigen_Form$;
function $m_Ldev_cheleb_scalamigen_Form$() {
  if ((!$n_Ldev_cheleb_scalamigen_Form$)) {
    $n_Ldev_cheleb_scalamigen_Form$ = new $c_Ldev_cheleb_scalamigen_Form$();
  }
  return $n_Ldev_cheleb_scalamigen_Form$;
}
export { $m_Ldev_cheleb_scalamigen_Form$ as $m_Ldev_cheleb_scalamigen_Form$ };
